import { forwardRef } from 'react'
import { Input, type InputType } from '@/common/ui/Form/Input/Input'

export type InputDateProps = Omit<InputType, 'type'>

export const InputDate = forwardRef<HTMLInputElement, InputDateProps>((props, ref) => {
    return <Input ref={ref} type='date' {...props} />
})

InputDate.displayName = 'InputDate'
